import { Step } from '../model/checkoutModel';

export const checkoutSteps: Step[] = ['userInfo', 'delivery', 'payment', 'receipt'];
